{
  "version": 1,
  "asset_id": "ab258a1b-9f5f-4dff-a0e8-eb6c4d4eadba",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/ab258a1b-9f5f-4dff-a0e8-eb6c4d4eadba/hero-6-de-abril.mp4",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/ab258a1b-9f5f-4dff-a0e8-eb6c4d4eadba/hero-6-de-abril.mp4",
  "original_filename": "hero-6-de-abril.mp4",
  "size": 302809,
  "content_type": "video/mp4",
  "created_at": "2026-11-04T13:09:19Z"
}
